import { ContextMenuOption } from '@y42/canvas-components';
import { TextAlignment } from '@y42/json-schema';
import { GojsFont } from '../models/gojs-font.model';

export const sidebarConfig = {
  shapeNode: {
    defaultShadow: {
      blur: 0,
      color: '#00000040',
      offset: { x: 0, y: 0 },
    },
    defaultLocked: false,
  },
  freeDrawNode: {
    defaultShadow: {
      blur: 0,
      color: '#00000040',
      offset: { x: 0, y: 0 },
    },
    defaultLocked: false,
  },
  textNode: {
    defaultFont: {
      fontFamily: 'Segoe UI',
      fontWeight: 'normal',
      fontSize: 22,
    } as GojsFont,
    defaultShadow: {
      blur: 0,
      color: '#00000040',
      offset: { x: 0, y: 0 },
    },
    defaultTextAlignment: TextAlignment.Left,
    defaultLocked: false,
  },
  stickyNode: {
    width: 190,
    height: 190,
    defaultShadow: {
      blur: 7,
      color: '#00000050',
      offset: { x: 1, y: 12 },
    },
    defaultFont: {
      fontFamily: 'Segoe UI',
      fontWeight: 'normal',
      fontSize: 20,
    },
  },
  nodeGroupNode: {
    width: 400,
    height: 200,
    defaultFont: {
      fontFamily: 'Segoe UI',
      fontWeight: 'normal',
      fontSize: 20,
    },
    defaultGroupTitle: 'Group Nodes Together',
    defaultGroupDescription: 'Group Description goes here...',
  },
  pinNode: {
    width: 40,
    height: 40,
    font: {
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontWeight: 'normal',
      fontSize: 12,
    },
  },
  colors: {
    shapeNode: {
      defaultBackground: '#e9e9f6',
      defaultBorderColor: '#5A9DEB',
    },
    freeDrawNode: {
      defaultBorderColor: '#000000',
    },
    textNode: {
      defaultTextColor: '#000000',
      darkModeTextColor: '#ffffff',
      defaultTextHighlightColor: undefined,
    },
    stickyNode: {
      defaultBackgroundColor: '#FFCF55',
      defaultTextColor: '#03053D',
    },
    pinNode: {
      backgroundColor: '#FFFFFF',
      textColor: 'white',
    },
    groupNode: {
      backgroundColor: 'transparent',
      borderColor: null,
    },
    link: {
      color: '#7A7A7A',
    },
  },
  diagramGrid: {
    color: '#d8d8d8',
    size: 50,
  },
  dragCreateTool: {
    minSize: 10,
    defaultSize: 100,
  },
};

export type nodeType =
  | 'shapeNode'
  | 'textNode'
  | 'stickyNode'
  | 'imageNode'
  | 'freeDraw'
  | 'groupNode'
  | 'pinNode'
  | 'attentionNode'
  | 'nodeGroupNode'
  | 'emojiNode';
export const sidebarLinkCategory = 'sidebarLink';

export const sidebarNodeTypes: Record<nodeType, nodeType> = {
  shapeNode: 'shapeNode',
  textNode: 'textNode',
  stickyNode: 'stickyNode',
  imageNode: 'imageNode',
  freeDraw: 'freeDraw',
  groupNode: 'groupNode',
  pinNode: 'pinNode',
  emojiNode: 'emojiNode',
  attentionNode: 'attentionNode',
  nodeGroupNode: 'nodeGroupNode',
};

const commonConfig: ContextMenuOption[] = ['bringToFrontBack', 'groupSelection', 'lock', 'delete'];
export const contextMenuConfig: Record<nodeType, ContextMenuOption[][]> = {
  shapeNode: [['shapeColor', 'shapeBorder', 'borderStyle', 'shadow'], commonConfig],
  freeDraw: [['lineColor', 'lineStyle'], commonConfig],
  textNode: [
    ['fontFamily'],
    ['fontSize'],
    ['fontWeight', 'textAlignment'],
    ['textColor', 'textHighlight', 'shadow'],
    commonConfig,
  ],
  stickyNode: [
    ['fontFamily'],
    ['fontSize'],
    ['fontWeight', 'textAlignment'],
    ['textColor', 'shapeColor', 'shadow'],
    commonConfig,
  ],
  imageNode: [commonConfig],
  groupNode: [commonConfig],
  pinNode: [],
  attentionNode: [['lock', 'delete']],
  emojiNode: [['lock', 'delete']],
  nodeGroupNode: [['alignNodes'], commonConfig],
};
